import { ISearchState } from './types'

const state: ISearchState = {
  lookup: '',
  results: [],
  selectedResultIndex: 0,
  accessToken: '',
  fundSearchApiEndpoint: '',
  canResultPanelOpen: false,
  cacheSuffix: '',
  mustHaveCacheSuffix: true, 
}

export default state

